import { render, staticRenderFns } from "./VolontarioDetail.vue?vue&type=template&id=764ba4b5&"
import script from "./VolontarioDetail.vue?vue&type=script&lang=ts&"
export * from "./VolontarioDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports